import React from "react";
import { Modal, Button } from "react-bootstrap";

const DirectionsMapModal = ({ show, onHide, travelMode, arrivalMode }) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  
  let origin = "Current+Location";
  if (arrivalMode === "plane") {
    origin = "YUL+Montreal+Airport";
  } else if (arrivalMode === "train") {
    origin = "Montreal+Central+Station";
  }

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Directions to Travelodge Hotel</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <iframe
          width="100%"
          height="400px"
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps/embed/v1/directions?key=${apiKey}&origin=${origin}&destination=Travelodge+Hotel+Montreal&mode=${travelMode}`}
        ></iframe>
      </Modal.Body>
      <Modal.Footer>
        {arrivalMode === "plane" && (
          <>
            <p style={{ paddingRight: "165px" }}>
              For Uber, please go to gate 28 at arrivals. For Taxi, go to gate
              23 for easy pick-up.
            </p>
            <p style={{ paddingRight: "475px" }}>
              <a
                href="/assets/montreal-airport-map.pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#007bff", textDecoration: "underline" }}
              >
                Click here for the airport map
              </a>
            </p>
          </>
        )}
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DirectionsMapModal;
